import { render, staticRenderFns } from "./ChangeForm.vue?vue&type=template&id=728d2e4b&scoped=true&"
import script from "./ChangeForm.vue?vue&type=script&lang=js&"
export * from "./ChangeForm.vue?vue&type=script&lang=js&"
import style0 from "./ChangeForm.vue?vue&type=style&index=0&id=728d2e4b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728d2e4b",
  null
  
)

export default component.exports